// @flow strict
import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import Sidebar from '../components/Sidebar';
import Page from '../components/Page';
import { useSiteMetadata } from '../hooks';
import type { MarkdownRemark } from '../types';
import Footer from '../components/Footer';

type Props = {
  data: {
    markdownRemark: MarkdownRemark
  }
};

const PageTemplate = ({ data }: Props) => {
  const { title: siteTitle, subtitle: siteSubtitle, url: siteTopLevelURL } = useSiteMetadata();
  const { html: pageBody } = data.markdownRemark;
  const { frontmatter, fields } = data.markdownRemark;
  const { title: pageTitle,
          description: pageMetaDescription = '',
          date: date,
          updated: updated,
        } = frontmatter;
  const { slug: slug} = fields; //I think this 'fields' version of the slug has been URL encoded including a prepend and trailing slash vs markdownremark's
  const metaDescription = pageMetaDescription || siteSubtitle;
  const pageMetaData = {
    siteTitle: siteTitle,
    siteURL: siteTopLevelURL,
    pageTitle: pageTitle,
    pageMetaDescription: metaDescription,
    pageURL: siteTopLevelURL + slug,
    publishedDate: date,
    updatedDate: updated,
    isBlogPost: false,
  }
  return (
    <Layout>
      <SEO metadata={pageMetaData} />
      <Sidebar />
      <Page title={pageTitle}>
        <div dangerouslySetInnerHTML={{ __html: pageBody }} />
      <Footer />
      </Page>
    </Layout>
  );
};

export const query = graphql`
  query PageBySlug($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      html
      fields {
        slug
      }
      frontmatter {
        title
        date
        description
      }
    }
  }
`;

export default PageTemplate;
